import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var XIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 19",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,7.622l3.536,-3.535c0.39,-0.39 1.023,-0.39 1.414,0c0.39,0.39 0.39,1.024 0,1.414l-3.536,3.536l3.536,3.535c0.39,0.39 0.39,1.024 0,1.414c-0.391,0.391 -1.024,0.391 -1.414,0l-3.536,-3.535l-3.536,3.535c-0.39,0.391 -1.023,0.391 -1.414,0c-0.39,-0.39 -0.39,-1.024 0,-1.414l3.536,-3.535l-3.536,-3.536c-0.39,-0.39 -0.39,-1.024 0,-1.414c0.391,-0.39 1.024,-0.39 1.414,0l3.536,3.535Z"
  }));
});
XIcon.displayName = 'XIcon';
export default XIcon;